import React from "react"
import { connect } from "react-redux"
import { Formik } from "formik"

import { searchDispatchAction } from "../../../../state/product/dispatchActions"
import {
  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS,
  getDefaultOrderByParams, getMissionDataByCodes,
  getMissionDescriptionsByCodes,
  isUpdateResultsSearchAvailable,
} from "../../../../helpers/configurationHelper"
import {
  extractFiltersBy,
  extractFinalValues,
  getInitialValueFromConfiguration,
  validateValuesFromConfiguration,
} from "../../../../helpers/dynamicFormHelper"
import {
  FIRST_SEARCH_PAGE_NUMBER,
  getMainInputConfigurationsBy,
  getPageSizeSearchDataFrom,
  getShapeSearchDataFrom,
} from "../../../../helpers/searchHelper"
import { AdvancedSearchConfigurationsType } from "../../../../types/configurations"
import { ShapeType } from "../../../../types/shape"
import { ProductImageStacType } from "../../../../types/product"
import SatelliteImageryForm from "./SatelliteImageryForm"
import { isOnlyStackSearchAvailable } from "../../../../helpers/interferometricStackHelper"
import { AppParametersType } from "../../../../types/app"

interface PropsType {
  configurations: AdvancedSearchConfigurationsType;
  isInterferometricStackSearch: boolean;
  lastShape: ShapeType;
  loadingInitialData: boolean;
  formData: any;
  selectedProducts: ProductImageStacType[];
  searchDispatchActionHandler: any;
  appParameters: AppParametersType;
  searchByProducts: any;
  searchProductIds: string;
}

const SatelliteImageryFormContainer = (props: PropsType) => {
  const {
    configurations,
    lastShape,
    loadingInitialData,
    formData,
    selectedProducts,
    searchDispatchActionHandler,
    isInterferometricStackSearch,
    appParameters,
    searchByProducts,
    searchProductIds
  } = props

  const mainInputConfigurations = getMainInputConfigurationsBy(configurations, appParameters)

  const onSubmitHandler = (formValues, actions) => {
    const values: any = extractFinalValues(
      mainInputConfigurations,
      configurations,
      appParameters,
      SCOPE_CONFIGURATION_FIELDS,
      lastShape,
      formValues
    )
    const isStackSearchAvailable =
      isInterferometricStackSearch ||
      isOnlyStackSearchAvailable(
        configurations,
        appParameters,
        SCOPE_CONFIGURATION_FIELDS,
        formValues
      )

    const dataToSend: any = {
      missions: getMissionDescriptionsByCodes(configurations, values.missions),
      indexes: getMissionDataByCodes(configurations, values.missions, values.dataset),
      from: values.date1,
      to: values.date2,
      routine: values.routine,
      orderBy: getDefaultOrderByParams(
        configurations,
        values,
        isStackSearchAvailable,
        appParameters.language
      ),
      pageNumber: FIRST_SEARCH_PAGE_NUMBER,
      pageSize: getPageSizeSearchDataFrom(appParameters, formData, values),
      ...getShapeSearchDataFrom(lastShape),
    }

    // @mapitaly: multimission deve mostrare i filtri in comune
    if (values.missions.length > 0 || searchByProducts) {
      dataToSend.filters = extractFiltersBy(
        configurations,
        appParameters,
        mainInputConfigurations,
        SCOPE_CONFIGURATION_FIELDS,
        values
      )
    }

    searchDispatchActionHandler(
      dataToSend,
      !isUpdateResultsSearchAvailable(configurations, appParameters, values, selectedProducts),
      isStackSearchAvailable,
      appParameters.language,
      searchByProducts,
      searchProductIds
    ).then((response) => {
      actions.setSubmitting(false)
    })

    return new Promise((a, b) => {}) // to prevent from isSubmitting issue
  }

  return (
    <Formik
      initialValues={getInitialValueFromConfiguration(mainInputConfigurations, configurations, appParameters, SCOPE_CONFIGURATION_FIELDS, lastShape)}
      validate={validateValuesFromConfiguration(mainInputConfigurations, configurations, appParameters, SCOPE_CONFIGURATION_FIELDS, lastShape, appParameters.language, searchByProducts)}
      onSubmit={onSubmitHandler}
    >
      {(formProps) => (
        <SatelliteImageryForm
          mainInputConfigurations={mainInputConfigurations}
          configurations={configurations}
          lastShape={lastShape}
          selectedProducts={selectedProducts}
          loadingInitialData={loadingInitialData}
          formProps={formProps}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  lastShape: state.geoMap.lastShape,
  loadingInitialData: state.application.loadingInitialData,
  formData: state.application.formData,
  selectedProducts: state.product.selectedProducts,
  searchByProducts: state.geoMap.searchByProducts,
  searchProductIds: state.geoMap.searchProductIds,
})

const mapDispatchToState = (dispatch) => ({
  searchDispatchActionHandler: (
    formData,
    isNewSearch,
    isInterferometricStackSearch,
    language,
    searchByProducts,
    searchProductIds
  ) => dispatch(
    searchDispatchAction(
      formData,
      isNewSearch,
      isInterferometricStackSearch,
      language,
      searchByProducts,
      searchProductIds
    )
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToState
)(SatelliteImageryFormContainer)
